import React from "react";
import { JobSearchHit, JobSearchResults } from "@themuse/design-system";

import {
    museTrack, getJobSearchHitTrackingProps, TrackedElement, JobTrackingProps
} from "utils/tracking";
import { SidebarJobTile } from "./SidebarJobTile";

import styles from "./JobIndividualSidebar.module.scss";

const sidebarJobTileClickedTracking = (
    event: React.SyntheticEvent<HTMLDivElement, Event>,
    trackingProps: JobTrackingProps
) => {
    museTrack("Job Tile Clicked", trackingProps);
};

export const SimilarJobsSidebarModule = (props: {similarJobs: JobSearchResults, jobId: number}) => {
    const { similarJobs, jobId } = props;
    // We only ever want a max of three jobs, and we don't want to include the job we are displaying, so we request 4 and filter it out
    const tiles = similarJobs?.hits?.filter((searchHit: JobSearchHit) => searchHit.hit.legacy_id !== jobId).slice(0, 3).map((searchHit: JobSearchHit, index: number) => {
        const { hit } = searchHit;
        const trackingProps = {
            ...getJobSearchHitTrackingProps(hit),
            ...{
                placement_position: "job detail page",
                placement: "Individual Job",
                order_num: index + 1,
                recommended: true,
            }
        };

        return (
            <TrackedElement key={hit.id} eventProps={trackingProps} eventName="Job Tile Viewed">
                <SidebarJobTile jobSearchData={hit} orderNum={index + 1} onClick={(event) => sidebarJobTileClickedTracking(event, trackingProps)} />
            </TrackedElement>
        );
    });

    return (
        similarJobs && similarJobs?.hits?.length ? (
            <div className={styles.similarJobsModule}>
                <h2>Similar Jobs</h2>
                <ul>
                    { tiles }
                </ul>
            </div>
        ) : null
    );
};
